<template>
    <div class="terminal-container">
        <div class="terminal">
            <p class="mb-0">
                <span class="machine-name">teamLead@sick-machine</span>
                <span class="path"> ~ $ </span>
                <vue-typer
                    :text="['composer require dynamite-developer']"
                    :repeat="0"
                    initial-action="typing"
                    :type-delay="70"
                    :pre-type-delay="1000"
                    caret-animation="blink"
                ></vue-typer>
            </p>
            <p v-if="packagesVisible" class="mb-0 machine-name">
                ./composer.json has been updated
            </p>
            <p v-if="packagesVisible" class="mb-0 machine-name">
                Running composer update dynamite-developer
            </p>
            <p v-if="packagesVisible" class="mb-0 machine-name">
                Loading composer repositories with package information
            </p>
            <p v-if="packagesVisible" class="mb-0 machine-name">
                Updating dependencies
            </p>
            <p v-if="packagesVisible" class="mb-0 machine-name">
                Package operations: 1 installs, 0 updates, 0 removals
            </p>
            <p v-if="packagesVisible" class="mb-0 ml-4">
                - Downloading <span class="machine-name">dynamite-developer/kevin-davis</span> (4.0)
            </p>
            <p v-if="packagesVisible" class="mb-0 ml-4">
                - Installing <span class="machine-name">dynamite-developer/kevin-davis</span> (4.0)
            </p>
            <p v-if="packagesVisible" class="machine-name">
                No security vulnerability advisories found.
            </p>
            <p v-if="commandEnd" class="mb-0">
                Using version ^4.0 for dynamite-developer/kevin-davis
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        mounted() {
            this.runCommandLine();
        },
        data() {
            return {
                packagesVisible: false,
                commandEnd: false
            };
        },
        methods: {
            runCommandLine() {
                let self = this;

                setTimeout(function() {
                    self.packagesVisible = true;
                }, 6000);

                setTimeout(function() {
                    self.commandEnd = true;
                }, 8000);
            }
        }
    };
</script>

<style>
    .vue-typer .custom.char.typed {
        color: #fff;
    }
    .vue-typer .custom.caret {
        color: #fff;
    }
    .vue-typer .custom.caret.typing {
        background-color: #fff;
    }
    .terminal {
        background: #000;
        margin-left: 25%;
        margin-right: 25%;
        color: #fff;
        padding: 2rem;
        font-family: monospace;
        border: 1px solid #fff;
        border-radius: 10px;
        position: relative;
        top: 35%;
    }
    .machine-name {
        color: #70ff3a;
    }
    .path {
        color: #4462ff;
    }
    .terminal-container {
        background: #000;
        height: 100vh;
        width: 100%;
    }
</style>

